class LanguageSelectorController {

    // TODO: CONSTANTS
    // static const SUFIX = '-label';

    constructor($translate, $state, CONFIG) {
        'ngInject';
        this.name = 'languageSelector';
        this.$translate = $translate;
        this.$state = $state;
        this.languages = CONFIG.languages;
    }

    $onInit() {
        let currentLanguage = this.$translate.proposedLanguage() || this.$translate.use();
        this.$translate.onReady().then(() => {
            this.setLanguage(currentLanguage);
        });
    }

    fetchLanguage(lang) {
        this.$translate.use(lang).then(() => {
            this.setLanguage(lang);
            this.$state.reload();
        });
    };

    setLanguage(lang) {
        this.language = this.languages[lang];
    }

}

export default LanguageSelectorController;


// WEBPACK FOOTER //
// ./client/app/common/languageSelector/languageSelector.controller.js